import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { BreadCrumbItem } from 'src/app/model/breadCrumb/breadCrumbItem';

@Component({
  selector: 'app-cosy-breadcrumb',
  templateUrl: './cosy-breadcrumb.component.html',
  styleUrls: ['./cosy-breadcrumb.component.css']
})
export class CosyBreadcrumbComponent implements OnInit {
  @Input() ie:InterfaceElement;
  @Input() breadCrumb: BreadCrumbItem[] = [];
  @Output() loadHistory: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {}

  loadHistoryFromBreadCrumb(item) {
    this.loadHistory.emit(item.sessionID);
  }

}
 

